/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether hero background is a static image or video
 * @export
 */
export const ChallengeHeroType = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO'
} as const;
export type ChallengeHeroType = typeof ChallengeHeroType[keyof typeof ChallengeHeroType];


export function instanceOfChallengeHeroType(value: any): boolean {
    for (const key in ChallengeHeroType) {
        if (Object.prototype.hasOwnProperty.call(ChallengeHeroType, key)) {
            if (ChallengeHeroType[key as keyof typeof ChallengeHeroType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChallengeHeroTypeFromJSON(json: any): ChallengeHeroType {
    return ChallengeHeroTypeFromJSONTyped(json, false);
}

export function ChallengeHeroTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeHeroType {
    return json as ChallengeHeroType;
}

export function ChallengeHeroTypeToJSON(value?: ChallengeHeroType | null): any {
    return value as any;
}

export function ChallengeHeroTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ChallengeHeroType {
    return value as ChallengeHeroType;
}

